import styled, { css } from 'styled-components';
import { suppressProps, makeBoxShadow } from '../../utils/index.js';
import { Stack } from '../stack/index.js';
import { Paragraph } from '../paragraph/index.js';
import { Field } from '../field/index.js';
export const RadioGroupElement = styled(Field) ``;
export const RadioButtonParagraphElement = styled(Paragraph) `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const getChipStyles = ({ variant, theme, }) => {
    if (variant === 'chips') {
        const { fontSizes, lineHeights, space, styles } = theme;
        const { lineHeight, fontSize } = styles.chip.variants.standard;
        return css `
      align-items: flex-start;
      flex-wrap: wrap;
      row-gap: ${space.x2};
      column-gap: ${space.x2};

      ${RadioButtonParagraphElement} {
        line-height: ${lineHeights[lineHeight]};
        font-size: ${fontSizes[fontSize]};
        color: inherit;
      }
    `;
    }
    return css ``;
};
const getOrientationStyles = ({ orientation, }) => {
    if (orientation === 'vertical') {
        return css `
      flex-direction: column;
    `;
    }
    return css `
    flex-direction: row;
    flex-wrap: wrap;
  `;
};
export const RadioGroupButtonsContainerElement = styled(Stack).withConfig(suppressProps('label', 'hiddenLabel', 'errorMessage', 'description'))(({ theme, label, hiddenLabel, errorMessage, description, }) => {
    const topMargin = label && !hiddenLabel ? theme.space.x2 : 0;
    const bottomMargin = errorMessage || description ? theme.space.x2 : 0;
    return css `
      margin-top: ${topMargin};
      margin-bottom: ${bottomMargin};
      row-gap: ${theme.space.x3};
      column-gap: ${theme.space.x4};
    `;
}, getOrientationStyles, getChipStyles);
const getRadioButtonDisabledStyles = ({ isDisabled, theme, }) => {
    if (!isDisabled) {
        return css ``;
    }
    return css `
    cursor: not-allowed;
    opacity: ${theme.styles.radioGroup.button.disabledOpacity};
  `;
};
const getRadioButtonFocusStyles = ({ isFocusVisible, isFocused, theme, }) => {
    if (!isFocusVisible || !isFocused) {
        return css ``;
    }
    return css `
    &::before {
      outline: ${theme.outlines.control.rule};
      outline-offset: ${theme.outlines.control.offset};
    }
  `;
};
const getRadioButtonHoverStyles = ({ isHovered, isSelected, theme, }) => {
    if (!isHovered || isSelected) {
        return css ``;
    }
    const boxShadow = makeBoxShadow(theme.styles.radioGroup.button.hoverBoxShadow, theme);
    const { activeBorderWidth, borderStyle, activeColor } = theme.styles.radioGroup.button;
    return css `
    &::before {
      border: ${activeBorderWidth} ${borderStyle} ${activeColor};
      box-shadow: ${boxShadow};
    }
  `;
};
const getRadioButtonActiveStyles = ({ isSelected, theme, }) => {
    if (!isSelected) {
        return css ``;
    }
    const { activeBorderWidth, borderStyle, activeColor } = theme.styles.radioGroup.button;
    return css `
    &::before {
      border: ${activeBorderWidth} ${borderStyle} ${activeColor};
    }
  `;
};
const getRadioButtonSelectedStyles = ({ isSelected, theme, }) => {
    if (!isSelected) {
        return css `
      &::after {
        display: none;
      }
    `;
    }
    return css `
    &::after {
      position: absolute;
      content: '';
      left: ${theme.space.x1};
      top: ${theme.space.x1_5};
      width: ${theme.sizes.x2};
      height: ${theme.sizes.x2};
      box-sizing: border-box;
      background-color: ${theme.styles.radioGroup.button.activeColor};
      border-radius: 50%;
      display: block;
    }
  `;
};
const getRadioButtonIcon = ({ theme }) => {
    const { activeBorderWidth, borderStyle, borderWidth, defaultColor, activeColor, marginRight, } = theme.styles.radioGroup.button;
    return css `
    &::before {
      content: '';
      flex-shrink: 0;
      width: ${theme.styles.icons.sizes.standard};
      height: ${theme.styles.icons.sizes.standard};
      box-sizing: border-box;
      border: ${borderWidth} ${borderStyle} ${defaultColor};
      border-radius: 50%;
      display: block;
      margin-right: ${marginRight};
    }

    &:hover &::before {
      border: ${activeBorderWidth} ${borderStyle} ${activeColor};
    }
  `;
};
export const RadioButtonLabelElement = styled.label.withConfig(suppressProps('isSelected', 'isDisabled', 'isHovered', 'isFocused', 'isFocusVisible'))(({ theme }) => css `
      display: grid;
      grid-template-columns: auto auto;
      align-items: center;
      justify-content: flex-start;
      row-gap: ${theme.space.x_5};
      cursor: pointer;
      position: relative;
      min-height: ${theme.styles.radioGroup.button.minHeight};
    `, getRadioButtonIcon, getRadioButtonDisabledStyles, getRadioButtonActiveStyles, getRadioButtonHoverStyles, getRadioButtonSelectedStyles, getRadioButtonFocusStyles);
export const RadioButtonInputElement = styled.input ``;
export const RadioButtonDescriptionElement = styled(Paragraph).attrs({
    variant: 'smallCompact',
    color: 'secondary',
}) `
  grid-column: 2;
`;
//# sourceMappingURL=radio-group.styles.js.map